export class AddressModel {
  /**
   * Отображаемое значение
   * @type {string}
   */
  value = null

  /**
   * Сырые данные от провайдера данных
   * @type {object}
   */
  raw = null

  /**
   * Данные для сохр на сервере
   * @type {AddressDataModel}
   */
  data = null

  addressIdFieldName = null

  houseFiasFieldName = null

  fiasFieldName = null

  constructor () {
    this.data = new AddressDataModel()
  }
}

export class AddressDataModel {
  id = null
  house_fias_id = null
  isNominatim = false
  isDadata = false
  isCustom = false
  isTree = false
  geo_lat = null
  geo_lon = null
  value = null
  city_type = null
  city = null
  settlement_type = null
  settlement = null
  street_type = null
  street = null
  house_type = null
  house = null

  setDadata (raw) {
    this.isDadata = true
    for (let key in raw.data) {
      this[key] = raw.data[key]
    }
  }

  setCustom (raw) {
    this.isCustom = true

    this.value = raw.name
    this.fias_id = raw.fias_id
    this.house_fias_id = raw.fias_id
  }

  setNominatim (raw) {
    this.isNominatim = true

    this.value = raw.display_name
    this.geo_lat = raw.lat
    this.geo_lon = raw.lon

    const {house_number, road, village, city} = raw.address
    /*
        $addressParts = [
            $address->city_type && $address->city ? "{$address->city_type} {$address->city}" : null,
            $address->city_district_type && $address->city_district ? "{$address->city_district_type} {$address->city_district}" : null,
            $address->settlement_type && $address->settlement ? "{$address->settlement_type} {$address->settlement}" : null,
            $address->street_type && $address->street ? "{$address->street_type} {$address->street}" : null,
            $address->house ? (($address->house_type ?? 'д') . " {$address->house}") : null,
            $address->block_type && $address->block ? "{$address->block_type} {$address->block}" : null
        ];
    */
    if (city) {
      this.city = city
      // у всех типов ставим пробел из-за осбе формирвоания $addressParts
      this.city_type = ' '
    }
    if (village) {
      this.settlement = village
      this.settlement_type = ' '
    }
    if (road) {
      this.street = road
      this.street_type = ' '
    }
    if (house_number) {
      this.house = house_number
      this.house_type = ' '
    }
  }

  setTree (selectedValues, val) {
    this.isTree = true
    for (let key in selectedValues) {
      this[key] = selectedValues[key]
    }

    this.value = val
  }
}
